import React from 'react'
import Button from './Button'

const ButtonIconWeek = (props) => {
  return (
    <Button
      icon="week"
      {...props}
    />
  )
}

export default ButtonIconWeek
